import React from "react";
import { motion } from "framer-motion";
import { Typography, Tooltip } from "antd";
import PackageFlightLegUnified from "../Common/UnifiedPackageFlightLeg/PackageFlightLegUnified";
import { formatPackageLegSeatsHe } from "../../utils/premiumPackageCardModel";
import "../Common/UnifiedPackageFlightLeg/PackageFlightLegUnified.css";

const { Text } = Typography;

const FlightFooterRow = ({ flight, title }) => {
  if (!flight) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="tw-text-center tw-p-4"
      >
        <Text type="secondary">אין נתוני טיסה זמינים</Text>
      </motion.div>
    );
  }

  const { depDate, arrDate } = flight;

  if (!depDate || !arrDate) {
    return (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        className="tw-text-center tw-p-4"
      >
        <Text type="secondary">נתוני הטיסה לא שלמים</Text>
      </motion.div>
    );
  }

  const isIncludeCheckedLuggage = Number(flight?.maxCheckedLuggageWeight) || 0;
  const isIncludeHandLuggage = Number(flight?.maxHandLuggageWeight) || 0;

  const seatsLine = formatPackageLegSeatsHe(flight);

  return (
    <Tooltip title={seatsLine || undefined} placement="top">
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
        style={{ margin: "12px 0" }}
      >
        <div className="pfu-card-shell" dir="rtl">
          <div className="pfu-itinerary">
            <div className="fpc__itinerary">
              <div className="fpc__legs-stack">
                <PackageFlightLegUnified
                  leg={flight}
                  labelHe={title || "טיסה"}
                  suppressLuggageChips
                />
              </div>
            </div>
          </div>

          <div className="pfu-luggage-summary">
            {seatsLine ? (
              <p className="pfu-luggage-summary__seats" dir="rtl">
                <strong>מקומות:</strong> {seatsLine}
              </p>
            ) : null}
            <p dir="rtl">
              <strong>תיק יד:</strong>{" "}
              {isIncludeHandLuggage > 0
                ? `${isIncludeHandLuggage} ק"ג כלול`
                : "בתוספת תשלום או לא כלול"}
            </p>
            <p dir="rtl">
              <strong>מזוודה:</strong>{" "}
              {isIncludeCheckedLuggage > 0
                ? `${isIncludeCheckedLuggage} ק"ג כלול`
                : "בתוספת תשלום או לא כלול"}
            </p>
          </div>

          <p className="pfu-disclaimer" dir="rtl">
            תנאי המטען משתנים לפי חברת התעופה. פרטים נוספים יתקבלו לאחר ההזמנה.
          </p>
        </div>
      </motion.div>
    </Tooltip>
  );
};

export default FlightFooterRow;
